import { REACT_APP_VAPID_PUBLIC_KEY, } from "../constants/app_routes";
import { DASHBOARD_API_URL } from "../constants/api_routes";
import axios from "axios";
import {getHeader} from "../data/user_api";



export async function isUserSubscribed() {
  if (!("serviceWorker" in navigator) || !("PushManager" in window)) {
    return false;
  }

  // Permission always wins
  if (Notification.permission !== "granted") {
    return false;
  }

  try {
    const registration = await navigator.serviceWorker.ready;
    const subscription = await registration.pushManager.getSubscription();
    return !!subscription;
  } catch (err) {
    console.error("Subscription check failed:", err);
    return false;
  }
}
async function cleanupStaleSubscription(registration) {
  try {
    const existing = await registration.pushManager.getSubscription();
    if (existing) {
      await existing.unsubscribe();
      console.log("Stale push subscription removed");
    }
  } catch (err) {
    console.warn("Failed to cleanup old subscription:", err);
  }
}

export const sendTestPushNotification = async () => {
  console.log("Sending test push notification...");

  try {
    const response = await axios.post(
      `${DASHBOARD_API_URL}/push_subscriptions/send_test`,
      {}, // no body needed
      { headers: getHeader() }
    );

    console.log("Test push response:", response.data);
    return { data: response.data, success: true };
  } catch (e) {
    let message = "Something went wrong. Try again";
    let status = 500;

    if (e.response) {
      status = e.response.status;
      if (e.response.data && e.response.data.message) {
        message = e.response.data.message;
      }
    }

    console.error("Failed to send test push:", message);
    return {
      message,
      status,
      success: false,
    };
  }
};

export const createPushSubscription = async (subscription) => {
    console.log("create sub called")
  try {
    // Call your :create endpoint
    const response = await axios.post(
      `${DASHBOARD_API_URL}/push_subscriptions/create`,
      subscription,
      { headers: getHeader() }
    );

    return { data: response.data, success: true };
  } catch (e) {
    let message = "Something went wrong. Try again";
    let status = 500;

    if (e.response) {
      status = e.response.status;

      if (e.response.data && e.response.data.errors) {
        message = e.response.data.errors.join(", ");
      }
    }

    return {
      message,
      status,
      success: false,
    };
  }
};
// Convert base64 VAPID key to Uint8Array
const vapidKeyToUint8Array = (base64String) => {
  if (!base64String) {
    throw new Error("VAPID key is missing");
  }

  return Uint8Array.from(
    atob(base64String.replace(/-/g, "+").replace(/_/g, "/")),
    c => c.charCodeAt(0)
  );
};


export function requestPushPermission() {
  if (!("Notification" in window)) {
    alert("Your browser does not support notifications.");
    return;
  }

  // HARD BLOCK — browser will never show a prompt
  if (Notification.permission === "denied") {
    alert(
      "Push notifications are currently blocked for this site.\n\n" +
      "To enable them:\n" +
      "• Open Chrome Settings\n" +
      "• Go to Site settings → Notifications\n" +
      "• Make sure the setting here for Notifications is set to Ask First\n" + 
      "If this site appears on the list at the bottom, set it to 'Allow'\n\n" +
      "Then reload this page and try again."
    );
    return;
  }

  // Normal flow
  Notification.requestPermission().then(permission => {
    console.log("Permission result:", permission);

    if (permission === "granted") {
      subscribeUser(); // safe now
    } else if (permission === "denied") {
        alert(
          "You blocked notifications.\n\n" +
          "You can enable them later from:\n" +
          "Chrome Settings → Site settings → Notifications"
        );
    }
  });
}

function isPushManagerActive(pushManager) {
    if (!pushManager) {
        if (!window.navigator.standalone) {
          window.alert("App not opened in standalone mode. Tap share - Add To Home Screen option in Safari and re-open using that")
        } else {
            window.alert("Error - Push Manager Not Active")
        }
        return false;
    } else {
        return true;
    }
}
export async function subscribeUserIOS() {

    let swRegistration = await navigator.serviceWorker.getRegistration();
    let pushManager = swRegistration.pushManager;
    if (!isPushManagerActive(pushManager)) {
        return;
    }
    let subscriptionOptions = {
        userVisibleOnly: true,
        applicationServerKey: vapidKeyToUint8Array(REACT_APP_VAPID_PUBLIC_KEY)
    };
    try {
        let subscription = await pushManager.subscribe(subscriptionOptions);
        const result = await createPushSubscription(subscription);
        if (!result.success) {
          window.alert(`Failed to persist subscription: ${result.message}`);
    } else (
      window.location.reload()
    )
    } catch (error) {
      console.log(error)
      window.alert("User Denied Permission")
    }
}


export async function subscribeUser() {
  try {
    if (!("serviceWorker" in navigator) || !("PushManager" in window)) {
      console.error("Push not supported");
      return;
    }

    // 1️⃣ Ask permission
    const permission = await Notification.requestPermission();
    if (permission !== "granted") {
      console.log("Notification permission not granted");
      return;
    }

    // 2️⃣ Wait for active SW (NO re-registering)
    const registration = await navigator.serviceWorker.ready;

    // 3️⃣ 🔴 CRITICAL: Remove broken subscriptions
    await cleanupStaleSubscription(registration);

    // 4️⃣ Subscribe
    const subscription = await registration.pushManager.subscribe({
      userVisibleOnly: true,
      applicationServerKey: vapidKeyToUint8Array(REACT_APP_VAPID_PUBLIC_KEY),
    });


    // 5️⃣ Send to backend
    const result = await createPushSubscription(subscription);

    if (!result.success) {
      window.alert("Failed to persist subscription:" + result.message);
    } else {
      window.alert("Push Subscription Successful")
      window.location.reload()
    }
  
  } catch (err) {
    console.error("Push subscription flow failed:", err);
  }
}




// WEBPACK FOOTER //
// ./src/utils/push_notifications.js